import { useEffect, useRef } from 'react';
import { BrowserRouter, Navigate, Route, Routes, useLocation } from 'react-router-dom';
import CommandMenu from './components/CommandMenu';
import Nav from './components/Nav';
import Footer from './components/Footer';
import Home from './pages/Home';
import BlogIndex from './pages/BlogIndex';
import BlogPage from './pages/BlogPage';
import VulnsPage from './pages/VulnsPage';
import FunPage from './pages/FunPage';

// The top gradient waves on every page, but only fades away (after ~1 min)
// while reading the blog.
function FadingBackdrop() {
  const { pathname } = useLocation();
  const ref = useRef(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return undefined;
    el.classList.remove('is-faded'); // reappears when leaving the blog
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return undefined;
    if (!pathname.startsWith('/blog')) return undefined;
    const t = setTimeout(() => el.classList.add('is-faded'), 60000);
    return () => clearTimeout(t);
  }, [pathname]);
  return <div ref={ref} className="backdrop" aria-hidden="true" />;
}

function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (!hash) window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
}

function Pages() {
  const { pathname } = useLocation();
  return (
    <div className="page" key={pathname}>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/blog" element={<BlogIndex />} />
        <Route path="/blog/:id" element={<BlogPage />} />
        <Route path="/vulns" element={<VulnsPage />} />
        {/* unlisted: not linked from nav, footer or the command menu */}
        <Route path="/fun" element={<FunPage />} />
        <Route path="/portfolio" element={<Navigate to="/" replace />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <a className="skip-link" href="#content">
        Skip to content
      </a>
      <CommandMenu />
      <div className="grain" aria-hidden="true" />
      <div className="scanlines" aria-hidden="true" />
      {/* Blurred gradient band at the top of the page, after rajan.sh */}
      <FadingBackdrop />
      <div className="app">
        <Nav />
        <Pages />
        <Footer />
      </div>
    </BrowserRouter>
  );
}
